import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class IfengIntroList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return <div className={styles.conChannel} dangerouslySetInnerHTML={{ __html: content.productsRight1 }} />;
    }
}

export default IfengIntroList;
